import styled from 'styled-components'

export const Header = styled.div`
	display: flex;
	align-items: center;
	column-gap: 12px;
	margin-bottom: 22px;
`
